export default "__VITE_ASSET__4c26a58d__"